import DisplayItem from './DisplayItem'

export default DisplayItem
